import { Component } from "react";

// Aísla un componente decorativo: si falla, no se renderiza y el resto de la
// app sigue funcionando.
export default class SilentErrorBoundary extends Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        console.warn("Componente desactivado por un error:", error);
    }

    render() {
        return this.state.hasError ? null : this.props.children;
    }
}
